import { Loading } from "element-ui";

export default class Load {
  constructor() {
    this._instance = null;
    this._loading = null;
    this._showDuration = 200;
    this._showTimer = null;
    this._closeDuration = 200;
    this._closeTimer = null;
  }
  static get instance() {
    if (!Load._instance) {
      Load._instance = new Load();
    }
    return Load._instance;
  }
  get showTimer() {
    return this._showTimer;
  }
  get closeTimer() {
    return this._closeTimer;
  }
  beforeShow() {
    this._loading = Loading.service({
      lock: true,
      text: "Loading",
      background: "rgba(0, 0, 0, 0.5)"
    });
  }
  show() {
    if (Load.instance.showTimer) return;

    this._showTimer = true;
    this.beforeShow();
  }
  close() {
    if (Load.instance.closeTimer) clearTimeout(this._closeTimer);

    this._closeTimer = setTimeout(() => {
      this._loading.close();
      this._showTimer = false;
    }, this._closeDuration);
  }
}



// WEBPACK FOOTER //
// ./src/utils/loading.js